<template>
	<div>
		<v-form ref="form" class="mx-2" lazy-validation>
			<h4 v-if="!onlySample && mode != 'edit'">عنوان قالب: {{ localData.title }}</h4>
			<v-text-field v-else-if="!onlySample" :disabled="mode != 'edit'" ref="title" v-model="localData.title" class="" label="عنوان قالب*" :error-messages="errorMessages" :rules="[() => !!localData.title || 'عنوان قالب را وارد کنید']" required />
			<h4 class="mt-1 mb-4" v-if="!onlySample && mode != 'edit'">دسته: {{ localData.category ? localData.category.title : 'نامشخص' }}</h4>
			<v-combobox v-else-if="!onlySample" v-model="localData.category" required :items="categories" label="دسته قالب" single-line :error-messages="errorMessages" item-text="title" item-value="id" />

			<div v-if="mode === 'edit' && !onlySample">
				<ul class="pattern-tags">
					<li v-for="tag in patternTags" :key="tag" @click="appendTag(tag)">{{ tag }}</li>
				</ul>
			</div>
			<div v-if="!onlySample" class="mt-2">
				<v-textarea v-model="localData.pattern" ref="pattern" :disabled="mode != 'edit'" outlined :error-messages="errorMessages" label="الگوی قالب*" hint="قالب پیامک پس از تایید توسط مدیر قابل استفاده می باشد." :rules="[() => !!localData.pattern || 'قالب را وارد کنید']" required />
			</div>

			<div style="font-size: 0.8rem;" class="mb-2" v-if="!onlySample || (onlySample && localData.pattern)">
				<div>نمونه پیامک:</div>
				<div v-html="sampleText" style="white-space: pre-line;">

				</div>
			</div>
			<div v-if="!onlySample" class="mt-2 grey lighten-2 pa-2">
				<v-checkbox class="mb-0" :disabled="mode != 'edit'" color="secondary" v-model="localData.isPatternBase" :label="'جهت استفاده در کدهای پترنی؟'" />
				<div class="d-flex" style="column-gap: 10px;">
					<v-select class="pt-0 mt-0" :disabled="mode != 'edit'" v-model="localData.smsPatternPanel" v-show="localData.isPatternBase" :items="smsPanels" label="انتخاب پنل پیامک" clearable required item-text="title" item-value="value"></v-select>
					<v-text-field class="pt-0 mt-0" :disabled="mode != 'edit'" v-model="localData.patternBaseCode" v-show="localData.isPatternBase" label="کد/نام پترن" />
				</div>
			</div>
			<div class="status" v-if="!onlySample">
				<v-row>
					<v-col cols="6">
						<div><span :style="{ 'color': statusColor }">وضعیت: {{ status }}</span></div>
						<a href="#" @click="rejectReasonDialog = true" v-if="this.localData.status === 2 && this.localData.rejectReason">مشاهده دلیل رد</a>
					</v-col>
					<v-col cols="6" class="align-end text-left">
						<v-btn :disabled="localData.isSystem" @click="update" v-if="mode !== 'edit' && !localData.isSystem" color="green" small dark>
							ویرایش
						</v-btn>
						<v-btn class="mx-1" @click="cancel" v-if="mode === 'edit' && !alwaysEdit" color="grey" small dark>
							انصراف
						</v-btn>
						<v-btn :loading="submitLoading" @click="save()" v-if="mode === 'edit' && !localData.isSystem" color="blue" small dark>
							ذخیره
						</v-btn>
						<v-btn v-if="!alwaysEdit && mode !== 'edit' && !localData.isSystem" class="mx-1" color="pink" @click="$emit('remove', localData.id)" dark small>
							حذف
						</v-btn>
						<!-- <a href="#" class="mx-1" v-if="mode !== 'edit' && !localData.isSystem" @click="mode='edit'">ویرایش</a>
					<a href="#" class="mx-1" v-if="mode === 'edit' && !localData.isSystem" @click="save()">ذخیره</a>
					<a href="#" class="mx-1" v-if="mode === 'edit' && !alwaysEdit" @click="mode='view'">انصراف</a> -->
						<!-- <v-btn class="" fab dark small color="pink" @click="remove()">
						<v-icon dark>
							mdi-trash-can-outline
						</v-icon>
					</v-btn> -->
					</v-col>
				</v-row>
			</div>
		</v-form>

		<v-dialog v-model="rejectReasonDialog" persistent max-width="450px">
			<v-card>
				<v-card-title>
					<div><span class="headline">دلیل رد قالب پیامک</span></div>
					<v-spacer />
					<v-btn @click="rejectReasonDialog = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<p>{{ localData.rejectReason }}</p>
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

	</div>
</template>

<script>
	import { emptyId } from '@/util/emptyId'
	import api from '@/util/app-api'
	import toast from '@/util/toast'

	export default {
		name: 'SmsPattern',
		props: {
			group: String,
			pattern: String,
			alwaysEdit: Boolean,
			onlySample: Boolean,
			data: Object
		},
		emits: ['remove', 'update', 'insert'],
		data() {
			return {
				rejectReasonDialog: false,
				errorMessages: '',
				mode: 'view',
				submitLoading: false,
				localData: { pattern: '' },
				originalData: {},
				replace: {
					'{نام مشتری}': 'مهدی قاسمی فرد',
					'{نام فروشگاه}': 'فروشگاه قاسمی فرد',
					'{مبلغ قسط}': 550000,
					'{شماره قسط}': 5,
					'{مبلغ واریز}': 550000,
					'{تاریخ واریز}': '1403-01-30',
					'{مانده وام}': 6500000,
					'{لینک پرداخت}': 'https://domain.ir/pop/100/1323213',
					'{بخش متغیر لینک پرداخت}': '100/1323213',
					'{مبلغ هر قسط}': 500000,
					'{مبلغ درخواستی}': 20000000,
					'{تعداد قسط}': 12,
					'{تاریخ درخواست}': '1403-05-05',
					'{نوع وام}': 'طرح بدون ضامن',
					'{شماره درخواست}': 1000,
					'{تاریخ تغییر وضعیت}': '1403-05-05',
					'{نام نماینده}': 'فروشگاه ما',
					'{وضعیت جدید}': 'اعطا شده',
					'{وضعیت جدید نماینده}': 'تسویه شده',
					'{سررسید واریز نماینده}': '1403-05-10',
					'{توسط نماینده با لیبل}': 'توسط نماینده داتیس',
					'{شماره پیگیری تراکنش}': '115100022233200',
					'{نام و نام خانوادگی}': 'محمد محمدی',
					'{نام کاربری}': 'admin',
					'{تاریخ}': '1403-05-05',
					'{تاریخ و ساعت}': '1403-05-05 10:15:06',
					'{آی پی}': '5.192.78.201',
					'{مرورگر}': 'chrome',
					'{رمز تاییدیه}': '54568',
				},
				smsPanels: [
					{ value: 2, title: 'ملی پیامک' },
					{ value: 3, title: 'کاوه نگار' },
				],
				categories: [
					{ value: 0, title: 'قسط' },
					{ value: 1, title: 'تغییر وضعیت' },
					{ value: 2, title: 'ورود به پنل' },
					{ value: 3, title: 'ثبت نام' },
					{ value: 4, title: 'کد تاییدیه ثبت نام' },
					{ value: 5, title: 'شارژ کیف پول' },
				],

			}
		},
		computed: {
			patternTags() {
				if (this.localData.category?.value === 1)
					return ['{نام مشتری}', '{نام فروشگاه}', '{مبلغ هر قسط}', '{مبلغ درخواستی}', '{تعداد قسط}', '{تاریخ درخواست}', '{نوع وام}', '{شماره درخواست}', '{تاریخ تغییر وضعیت}', '{نام نماینده}', '{وضعیت جدید}', '{وضعیت جدید نماینده}', '{سررسید واریز نماینده}', '{توسط نماینده با لیبل}']

				if (this.localData.category?.value === 2 || this.localData.category?.value === 3)
					return ['{نام و نام خانوادگی}', '{نام کاربری}', '{تاریخ}', '{تاریخ و ساعت}', '{آی پی}', '{مرورگر}']

				if (this.localData.category?.value === 4)
					return ['{رمز تاییدیه}', '{تاریخ}', '{تاریخ و ساعت}', '{آی پی}', '{مرورگر}']

				if (this.localData.category?.value === 5)
					return ['{نام مشتری}', '{نام فروشگاه}', '{لینک پرداخت}', '{تاریخ}']

				return ['{نام مشتری}', '{نام فروشگاه}', '{مبلغ قسط}', '{شماره قسط}', '{مبلغ واریز}', '{تاریخ واریز}', '{مانده وام}', '{لینک پرداخت}', '{بخش متغیر لینک پرداخت}', '{شماره پیگیری تراکنش}']
			},
			sampleText() {
				return this.convertPatternToSample(this.localData?.pattern)
			},
			status() {
				switch (this.localData.status) {
					case 0:
						return 'در انتظار بررسی'
					case 1:
						return 'تایید شده'
					case 2:
						return 'رد شده'
					default:
						return '-'
				}
			},
			statusColor() {
				switch (this.localData.status) {
					case 0:
						return 'orange'
					case 1:
						return 'green'
					case 2:
						return 'red'
					default:
						return 'grey'
				}
			}
		},
		created() {
			this.mode = this.alwaysEdit ? 'edit' : 'view'
			if (this.data) {
				this.localData = { ...this.data }
				this.localData.category = this.categories.find(x => x.value === this.localData.category)
			}
			if (this.alwaysEdit)
				this.localData.id = emptyId
		},
		watch: {
			data: {
				deep: true,
				immediate: true,
				handler(val) {
					this.localData = val || {pattern:''}
				}
			}
		},
		methods: {
			convertPatternToSample(pattern) {
				const replaceAll = (str, find, replace) => {
					return str.toString().replace(new RegExp(find, 'g'), replace)
				}
				if (!pattern)
					return ''
				for (var tag of this.patternTags) {
					pattern = replaceAll(pattern, tag, this.replace[tag])
				}
				return pattern
			},
			save() {
				if (!this.$refs.form.validate()) { return }
				this.submitLoading = true
				let data = {}
				Object.assign(data, this.localData)
				data.category = this.localData.category.value
				api.post('admin/smsPattern/' + (this.localData.id === emptyId ? 'create' : 'edit'), data)
					.then(
						response => {
							toast.success('اطلاعات با موفقیت ذخیره شد.')
							if (this.localData.id === emptyId) {
								this.$emit('insert', response)
								this.localData = { id: emptyId }
							}
							else
								this.$emit('update', response)
							this.mode = 'view'
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.submitLoading = false })
			},
			appendTag(tag) {
				const insertAtCursor = (myField, myValue) => {
					//IE support
					if (document.selection) {
						myField.focus()
						sel = document.selection.createRange()
						sel.text = myValue
					}
					//MOZILLA and others
					else if (myField.selectionStart || myField.selectionStart == '0') {
						var startPos = myField.selectionStart
						var endPos = myField.selectionEnd
						var val = myField.value.substring(0, startPos)
							+ myValue
							+ myField.value.substring(endPos, myField.value.length)
						return val
						// myField.value = val
					} else {
						return myField.value + myValue
						// myField.value += myValue
					}
				}
				var textarea = this.$refs.pattern.$el?.querySelector('textarea')
				if (textarea) {
					this.localData.pattern = insertAtCursor(textarea, tag)
					textarea.focus()
				}
			},
			update() {
				this.mode = 'edit'
				this.originalData = { ...this.localData }
			},
			cancel() {
				this.mode = 'view'
				this.localData = { ...this.originalData }
			}
		}
	}
</script>
<style scoped>
	.pattern-tags {
		list-style: none;
	}

	.pattern-tags li {
		display: inline;
		margin: 3px;
		color: blueviolet;
		cursor: pointer;
	}

	.status {
		border-top: 1px dashed #9e9e9e;
		padding: 10px;
	}
</style>
